export enum Languages {
  Afrikaans = 'af', // Afrikaans
  Akan = 'ak', // Akan
  Amharic = 'am', // Amharic
  Arabic = 'ar', // Arabic
  Assamese = 'as', // Assamese
  Aymara = 'ay', // Aymara
  Azerbaijani = 'az', // Azerbaijani
  Belarusian = 'be', // Belarusian
  Bulgarian = 'bg', // Bulgarian // deepl
  Bhojpuri = 'bho', // Bhojpuri
  Bambara = 'bm', // Bambara
  Bengali = 'bn', // Bengali
  Bosnian = 'bs', // Bosnian
  Catalan = 'ca', // Catalan
  Cebuano = 'ceb', // Cebuano
  Corsican = 'co', // Corsican
  Czech = 'cs', // Czech // deepl
  Welsh = 'cy', // Welsh
  Danish = 'da', // Danish // deepl
  German = 'de', // German // deepl
  Dogri = 'doi', // Dogri
  Divehi = 'dv', // Divehi
  Ewe = 'ee', // Ewe
  Greek = 'el', // Greek // deepl
  English = 'en', // English // deepl
  Esperanto = 'eo', // Esperanto
  Spanish = 'es', // Spanish // deepl
  Estonian = 'et', // Estonian // deepl
  Basque = 'eu', // Basque
  Persian = 'fa', // Persian
  Finnish = 'fi', // Finnish // deepl
  Filipino = 'fil', // Filipino (Tagalog)
  French = 'fr', // French // deepl
  Frisian = 'fy', // Frisian
  Irish = 'ga', // Irish
  ScotsGaelic = 'gd', // Scots Gaelic
  Galician = 'gl', // Galician
  Guarani = 'gn', // Guarani
  GoanKonkani = 'gom', // Goan Konkani
  Gujarati = 'gu', // Gujarati
  Hausa = 'ha', // Hausa
  Hawaiian = 'haw', // Hawaiian
  Hebrew = 'he', // Hebrew
  Hindi = 'hi', // Hindi
  Hmong = 'hmn', // Hmong
  Croatian = 'hr', // Croatian
  Hungarian = 'hu', // Hungarian // deepl
  HaitianCreole = 'ht', // Haitian Creole
  Armenian = 'hy', // Armenian
  Indonesian = 'id', // Indonesian // deepl
  Igbo = 'ig', // Igbo
  Iloko = 'ilo', // Iloko
  Icelandic = 'is', // Icelandic
  Italian = 'it', // Italian // deepl
  Japanese = 'ja', // Japanese // deepl
  Javanese = 'jw', // Javanese
  Georgian = 'ka', // Georgian
  Kazakh = 'kk', // Kazakh
  Khmer = 'km', // Khmer
  Kannada = 'kn', // Kannada
  Korean = 'ko', // Korean // deepl
  Krio = 'kri', // Krio (Sierra Leone)
  Kurdish = 'ckb', // Kurdish
  Kyrgyz = 'ky', // Kyrgyz
  Latin = 'la', // Latin
  Luxembourgish = 'lb', // Luxembourgish
  Ganda = 'lg', // Ganda
  Lingala = 'ln', // Lingala
  Lao = 'lo', // Lao
  Lithuanian = 'lt', // Lithuanian // deepl
  Mizo = 'lus', // Mizo
  Latvian = 'lv', // Latvian // deepl
  Maithili = 'mai', // Maithili
  Malagasy = 'mg', // Malagasy
  Maori = 'mi', // Maori
  Manipuri = 'mni-Mtei', // Manipuri
  Macedonian = 'mk', // Macedonian
  Malayalam = 'ml', // Malayalam
  Mongolian = 'mn', // Mongolian
  Marathi = 'mr', // Marathi
  Malay = 'ms', // Malay
  Maltese = 'mt', // Maltese
  Burmese = 'my', // Burmese
  // NorwegianBokmal = 'nb', // Norwegian (Bokmål) // deepl // Simple Norwegian uses Bokmal anyway
  Nepali = 'ne', // Nepali
  Dutch = 'nl', // Dutch // deepl
  Norwegian = 'no', // Norwegian
  NorthernSotho = 'nso', // Northern Sotho
  Nyanja = 'ny', // Nyanja
  Oromo = 'om', // Oromo
  Odia = 'or', // Odia
  Punjabi = 'pa', // Punjabi
  Polish = 'pl', // Polish // deepl
  Pashto = 'ps', // Pashto
  PortuguesePT = 'pt-PT', // Portuguese (Portugal) // deepl
  PortugueseBR = 'pt-BR', // Portuguese (Brazil) // deepl
  Quechua = 'qu', // Quechua
  Romanian = 'ro', // Romanian // deepl
  Russian = 'ru', // Russian // deepl
  Kinyarwanda = 'rw', // Kinyarwanda
  Sanskrit = 'sa', // Sanskrit
  Sindhi = 'sd', // Sindhi
  Sinhala = 'si', // Sinhala
  Slovak = 'sk', // Slovak // deepl
  Slovenian = 'sl', // Slovenian // deepl
  Samoan = 'sm', // Samoan
  Shona = 'sn', // Shona
  Somali = 'so', // Somali
  SouthernSotho = 'st', // Southern Sotho
  Albanian = 'sq', // Albanian
  Serbian = 'sr', // Serbian
  Sundanese = 'su', // Sundanese
  Swedish = 'sv', // Swedish // deepl
  Swahili = 'sw', // Swahili
  Tamil = 'ta', // Tamil
  Telugu = 'te', // Telugu
  Tigrinya = 'ti', // Tigrinya
  Tajik = 'tg', // Tajik
  Thai = 'th', // Thai
  Tagalog = 'tl', // Tagalog
  Turkish = 'tr', // Turkish // deepl
  Tsonga = 'ts', // Tsonga
  Tatar = 'tt', // Tatar
  Uyghur = 'ug', // Uyghur
  Ukrainian = 'uk', // Ukrainian // deepl
  Urdu = 'ur', // Urdu
  Uzbek = 'uz', // Uzbek
  Vietnamese = 'vi', // Vietnamese
  Xhosa = 'xh', // Xhosa
  Yiddish = 'yi', // Yiddish
  Yoruba = 'yo', // Yoruba
  Chinese = 'zh', // Chinese // 'zh-CN', // Chinese (Simplified) (Mandarin/China) // deepl
  ChineseTraditional = 'zh-TW', // Chinese (Traditional) (Mandarin/Taiwan)
  Zulu = 'zu', // Zulu
  Dari = 'prs', // Dari
}

const LANGUAGE_VALUES = Object.values(Languages);

export default LANGUAGE_VALUES;
